module.exports = __webpack_public_path__ + "static/media/email_logo.92c04432.svg";